import { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { useAuth } from "../contexts/AuthContext";
import { isNotificationUnread } from "../Components/utils/adminNotifications";

export default function useUserNotifications() {
  const { currentUser } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.uid) {
      setNotifications([]);
      setUnreadCount(0);
      setLoading(false);
      return;
    }

    const db = getDatabase();
    const notificationsRef = ref(db, `userNotifications/${currentUser.uid}`);

    const unsubscribe = onValue(
      notificationsRef,
      (snapshot) => {
        const items = [];
        let unread = 0;

        if (snapshot.exists()) {
          snapshot.forEach((child) => {
            const notification = { id: child.key, ...child.val() };
            items.push(notification);
            if (isNotificationUnread(notification)) {
              unread++;
            }
          });
        }

        items.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
        setNotifications(items);
        setUnreadCount(unread);
        setLoading(false);
      },
      (error) => {
        console.error("Error listening to user notifications:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [currentUser?.uid]);

  return { notifications, unreadCount, loading, userId: currentUser?.uid };
}
